import { Switch } from "@microsoft/shifts-ui-core";
import { makeStyles } from "../../packages/fluent9";
import * as React from "react";

const useStyles = makeStyles({
    switchIndicatorOverride: {
        "& .fui-Switch__indicator": {
            marginLeft: "0",
            marginRight: "0"
        },
        "& .fui-Switch__label": {
            fontSize: "10px",
            lineHeight: "16px",
            marginLeft: "12px",
            paddingLeft: "0"
        }
    }
});

export interface ShiftSwitchProps extends React.ComponentProps<typeof Switch> {}

export const ShiftSwitch: React.FC<ShiftSwitchProps> = (props) => {
    const styles = useStyles();

    return (
        <Switch
            {...props}
            label={props.label}
            className={`${styles.switchIndicatorOverride} ${props.className || ""}`}
            aria-label={(props["aria-label"] || props.label || "Switch") as string}
        />
    );
};